import { RouteAction } from '@lwtears/lwt-common-frontend/lib/Modal/hooks/util';
import { AppRoutes } from '../types';

export const getActivitySelectionModalRoute = (letter: string): string => {
  return `/${AppRoutes.LETTER_TEACHING}/${letter}/${AppRoutes.LETTER_BOOK}?action=${AppRoutes.ACTIVITY_SELECTION}-${RouteAction.MODAL_TYPE}`;
};
